<template>
    <div class="mt-10">
        <div class="grid md:grid-cols-3 gap-4">
            <tranche-card v-for="item in tranches" :key="item.uuid" :tranche="item" @click.native="invest(item)"/>
        </div>
    </div>
</template>

<script>

import TrancheCard from '@product-common/components/tranches2/TrancheCard'

export default {
    components: {
        TrancheCard
    },
    props: {
        tranches: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            comingSoonItems: [
                {
                    countryOfOrigin: 'United Kingdom',
                    tenure: '36',
                    paymentFrequency: 'monthly',
                    interestRate: 10,
                    creditLimit: 3.0,
                    currency: '$'
                },
                {
                    countryOfOrigin: 'Singapore',
                    tenure: '36',
                    paymentFrequency: 'monthly',
                    interestRate: 10,
                    creditLimit: 1.5,
                    currency: 'S$'
                },
            ]
        }
    },
    methods: {
        invest (item) {
            this.$emit('invest', item.uuid)
        }
    }
}
</script>


